var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 7.33306C14.5 3.44408 11.3656 0.290771 7.5 0.290771C3.63438 0.290771 0.5 3.44408 0.5 7.33306C0.5 10.8479 3.05938 13.7613 6.40625 14.2901V9.36935H4.62844V7.33306H6.40625V5.78155C6.40625 4.01689 7.45156 3.04135 9.05031 3.04135C9.81625 3.04135 10.6175 3.17905 10.6175 3.17905V4.91227H9.73438C8.86531 4.91227 8.59344 5.4549 8.59344 6.01263V7.33306H10.5347L10.2247 9.36935H8.59375V14.2908C11.9406 13.7623 14.5 10.8489 14.5 7.33306Z",
    fill: "#4E944F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/Fb.885b89ac49c1548c4af69e65108c8da2.svg";
export { ForwardRef as ReactComponent };